export const SET_DAYS = 'SET_DAYS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_USERS = 'SET_USERS'
export const SET_USER = 'SET_USER'
export const SET_USER_CHECKED = 'SET_USER_CHECKED'
export const ADD_USER = 'ADD_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_ROLES = 'SET_ROLES'
export const SET_FIRM = 'SET_FIRM'
export const SET_PRIMARY_FIRM = 'SET_PRIMARY_FIRM'
export const SET_USER_FIRMS = 'SET_USER_FIRMS'

export const USER_ORDER_BY = 'user/orderBy'
export const USER_SORT_DIR = 'user/sortDir'
export const USER_DAYS = 'user/days'
export const USER_PAGE_SIZE = 'user/pageSize'
export const USER_SEARCH_TERM = 'user/searchTerm'
export const USER_FILTER_BY = 'user/filterBy'



// WEBPACK FOOTER //
// ./src/store/modules/users/types.js